/**
@ngdoc directive
@name watchHelper

@description
Observe model and fire callback whenever it's changes.

@usage
<input type="hidden"
    watchHelper="formModel.groupOfFields"
    on-change="
        listingModel.suppliers.refresh = listingModel.suppliers.refresh+1;
        xmsNotifications.addObj({id: 'actionPostSuccessMsg', type: 'success', bodyHtml: 'Command executed successfully!'});
        formModel.myVariable = ajaxResponse().property"
    />
<!-- (it doesn't need to be hidden input, can be any element) -->

*/

(function() {
    'use strict';

    var watchHelper = function() {
        return {
            restrict: "A",
            scope: true,
            bindToController: {
               ngModel: "&watchHelper",
               onWatchedChange:"@"
            },
            controllerAs: 'ctrl',
            controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){
                var _this = this;
                $scope.$watch(
                    function(){
                        return _this.ngModel();
                    },
                    function(newVal, oldVal){
                        var ltdCoReadyOld, ltdCoReadyNew;
                        if(oldVal.hasOwnProperty('ltdCoReady') && newVal.hasOwnProperty('ltdCoReady')){
                            ltdCoReadyOld = oldVal.ltdCoReady;
                            ltdCoReadyNew = newVal.ltdCoReady;
                            oldVal.ltdCoReady = false;
                            newVal.ltdCoReady = false;
                        }
                        if(!angular.equals(newVal, oldVal)){
                            $scope.$eval(_this.onWatchedChange);
                        }
                        if(oldVal.hasOwnProperty('ltdCoReady') && newVal.hasOwnProperty('ltdCoReady')){
                            oldVal.ltdCoReady = ltdCoReadyOld;
                            newVal.ltdCoReady = ltdCoReadyNew;
                        }
                    },
                    true // deep watch
                );
            }]
        };
    }
    angular.module('app').directive('watchHelper', watchHelper);

}());